export default {"src":"/_next/static/media/thatMate.14caaee1.svg","height":49,"width":55};